module.exports = {
  unknown: {
    key: 'unknown',
    label: 'Unknown',
    icon: 'sexGenderUnknown',
  },
  female: {
    key: 'female',
    label: 'Female',
    icon: 'sexGenderFemale',
  },
  male: {
    key: 'male',
    label: 'Male',
    icon: 'sexGenderMale',
  },
  nonbinary: {
    key: 'nonbinary',
    label: 'Non-Binary',
    icon: 'sexGenderTrans',
  },
  other: {
    key: 'other',
    label: 'Other',
    icon: 'sexGenderOther',
  },
};